import {
	createRouter,
	createWebHistory,createWebHashHistory
} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import index from '../views/index.vue'

// 新闻资讯
import companyNews from '../views/news/companyNews.vue'
import newsInfo from '../views/news/newsInfo.vue'

// 底部菜单
import aboutUs from '../views/footerPage/aboutUs.vue'
import concatUs from '../views/footerPage/concatUs.vue'
import smartAgriculture from '../views/footerPage/smartAgriculture.vue'
import financialService from '../views/footerPage/financialService.vue'
import oneItemOneCode from '../views/footerPage/oneItemOneCode.vue'

// 智能装备
import smartEquipment from '../views/smartEquipment/smartEquipment.vue'

//产品与服务
import ica from '../views/productsAndServices/ica.vue' //ica
import gjldmx from '../views/productsAndServices/gjldmx.vue' //广积粮大模型
import dkyg from '../views/productsAndServices/dkyg.vue' //低空遥感
import xlsy from '../views/productsAndServices/xlsy.vue' //星链溯源
import huoguogo from '../views/productsAndServices/huoguogo.vue' //火锅产业
import ai from '../views/productsAndServices/ai.vue' //火锅产业
import facilityAgriculture from '../views/productsAndServices/facilityAgriculture.vue' //设施农业
import typicalCase from '../views/productsAndServices/typicalCase.vue' //典型案例
import fieldCultivation from '../views/productsAndServices/fieldCultivation.vue' //大田种植
import smartFarming from '../views/productsAndServices/smartFarming.vue' //智慧养殖
import industrialBrain from '../views/productsAndServices/industrialBrain.vue' //产业大脑
import agriculture from '../views/productsAndServices/agriculture.vue' //数字三农

const routes = [{
		path: '/',
		redirect: '/index' // 重定向到首页
	},
	{
		path: '/index',
		name: 'index',
		component: index,
		children: [{
				path: '', // 改为空路径，表示默认子路由
				name: 'home',
				component: HomeView,
			},
			{
				path: '/companyNews', // 相对路径
				name: 'companyNews',
				component: companyNews,
			},
			{
				path: '/newsInfo',
				name: 'newsInfo',
				component: newsInfo,
			},
			{
				path: '/aboutUs',
				name: 'aboutUs',
				component: aboutUs,
			},
			{
				path: '/concatUs',
				name: 'concatUs',
				component: concatUs,
			},
			{
				path: '/smartAgriculture',
				name: 'smartAgriculture',
				component: smartAgriculture,
			},
			{
				path: '/financialService',
				name: 'financialService',
				component: financialService,
			},
			{
				path: '/oneItemOneCode',
				name: 'oneItemOneCode',
				component: oneItemOneCode,
			},{
				path: '/ica',
				name: 'ica',
				component: ica,
			},{
				path: '/gjldmx',
				name: 'gjldmx',
				component: gjldmx,
			},{
				path: '/dkyg',
				name: 'dkyg',
				component: dkyg,
			},{
				path: '/xlsy',
				name: 'xlsy',
				component: xlsy,
			},{
				path: '/huoguogo',
				name: 'huoguogo',
				component: huoguogo,
			},{
				path: '/ai',
				name: 'ai',
				component: ai,
			},{
				path: '/smartEquipment',
				name: 'smartEquipment',
				component: smartEquipment,
			},{
				path: '/facilityAgriculture',
				name: 'facilityAgriculture',
				component: facilityAgriculture,
			},{
				path: '/typicalCase',
				name: 'typicalCase',
				component: typicalCase,
			},{
				path: '/fieldCultivation',
				name: 'fieldCultivation',
				component: fieldCultivation,
			},{
				path: '/smartFarming',
				name: 'smartFarming',
				component: smartFarming,
			},{
				path: '/industrialBrain',
				name: 'industrialBrain',
				component: industrialBrain,
			},{
				path: '/agriculture',
				name: 'agriculture',
				component: agriculture,
			}
		]
	},
	{
		path: '/about',
		name: 'about',
		component: () => import('../views/AboutView.vue')
	}
]

// const routes = [{
// 		path: '/', // 改为空路径，表示默认子路由
// 		name: 'home',
// 		component: HomeView,
// 	},
// 	{
// 		path: '/about',
// 		name: 'about',
// 		component: () => import('../views/AboutView.vue')
// 	}
// ]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      top: 0
    }
  }
})

// const router = createRouter({
// 	history: createWebHistory(process.env.BASE_URL),
// 	// 移除 mode: 'history'，因为 Vue Router 4 已经不再使用这个选项
// 	routes
// 	// scrollBehavior(to, from, savedPosition) {
// 	//   if (savedPosition) {
// 	//     return savedPosition
// 	//   }
// 	//   return {
// 	//     top: 0
// 	//   }
// 	// }
// })

// 添加路由导航守卫进行调试
router.beforeEach((to, from, next) => {
	console.log('路由跳转:', to.path)
	next()
})

router.afterEach((to, from) => {
	console.log('路由跳转完成:', to.path)
})

export default router